/**
 * Device capability profile returned by GET /devices/{sn}/capabilities.
 * UI should render controls from these flags instead of hardcoded model checks.
 */
export interface DeviceCapability {
  model_key: string
  model_name: string
  cameras: string[]
  sensors: string[]
  payload_commands: string[]
  thermal: boolean
  laser_range_finder: boolean
  live_video_types: string[]
  runtime_source: 'static' | 'merged' | 'live_capacity'
}

export enum CapabilityCamera {
  WIDE = 'wide',
  MEDIUM_TELE = 'medium_tele',
  TELE = 'tele',
  THERMAL = 'thermal',
  ZOOM = 'zoom',
}

export enum CapabilitySensor {
  LASER_RANGE_FINDER = 'laser_range_finder',
  RTK = 'rtk',
  NIR_ILLUMINATOR = 'nir_illuminator',
}

export function hasCapability (cap: DeviceCapability | null | undefined, camera: CapabilityCamera): boolean {
  return !!cap?.cameras?.includes(camera)
}

export function supportsPayloadCommand (cap: DeviceCapability | null | undefined, cmd: string): boolean {
  return !!cap?.payload_commands?.includes(cmd)
}
